/* istanbul ignore file */
import { Route, AppId, createPageRoute } from '@lumapps/router';

export const searchAnalyticsRoute: Route = createPageRoute({
    slug: 'analytics/search',
    appId: AppId.backOffice,
});
